// This import loads the firebase namespace along with all its type information.
import * as firebase from 'firebase/app';

// These imports load individual services into the firebase namespace.
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAjW31wgJlckbNXy5iKbOMXN3V0Cq6hsH4",
  authDomain: "lippumaatti.firebaseapp.com",
  databaseURL: "https://lippumaatti.firebaseio.com",
  projectId: "lippumaatti",
  storageBucket: "lippumaatti.appspot.com",
  messagingSenderId: "543074153885",
  appId: "1:543074153885:web:3748ec79abfd5a56"
};

const app = firebase.initializeApp(firebaseConfig);

export default firebase



// WEBPACK FOOTER //
// ./utils/firebase.js